import { ObjectTypes } from '../types';
import { FiStateNames } from '../fi-state-proxy/fi-state-names';
import { RawParams } from '@uirouter/angular';

export function getObjectViewStateData(
    objectType: ObjectTypes,
    objectId: number,
    args?: {
        taskV2Mode?: boolean;
    },
): { sref: string; srefParams: RawParams } {
    switch (objectType) {
        case ObjectTypes.MediaBank:
            return { sref: FiStateNames.MediaBank.View, srefParams: { Id: objectId } };
        case ObjectTypes.Document:
            return { sref: FiStateNames.Document.View, srefParams: { Id: objectId } };
        case ObjectTypes.Post:
            return { sref: FiStateNames.PostView, srefParams: { objectId: objectId, objectType: objectType } };
        case ObjectTypes.Template:
            return { sref: FiStateNames.Document.Template.View, srefParams: { Id: objectId } };
        case ObjectTypes.Forum:
            return { sref: FiStateNames.Forum.View, srefParams: { id: objectId } };
        case ObjectTypes.ForumPost:
            return { sref: FiStateNames.PostView, srefParams: { objectId: objectId, objectType: objectType } };
        case ObjectTypes.User:
            return { sref: FiStateNames.User.List, srefParams: { UserId: objectId } };
        case ObjectTypes.Role:
            return { sref: FiStateNames.Role.View, srefParams: { Id: objectId } };
        case ObjectTypes.Area:
            return { sref: FiStateNames.Area.View, srefParams: { Id: objectId } };
        case ObjectTypes.BusinessArea:
            return { sref: FiStateNames.BusinessArea.View, srefParams: { Id: objectId } };
        case ObjectTypes.BusinessUnit:
            return { sref: FiStateNames.BusinessUnit.List, srefParams: { BusinessUnitId: objectId } };
        case ObjectTypes.Cluster:
            return { sref: FiStateNames.Cluster.View, srefParams: { Id: objectId } };
        case ObjectTypes.Tag:
            return { sref: FiStateNames.Tag.View, srefParams: { Id: objectId } };
        case ObjectTypes.SiteMap:
            return { sref: FiStateNames.SiteMap.View, srefParams: { Id: objectId } };
        case ObjectTypes.CheckList:
            return { sref: FiStateNames.Checklist.View, srefParams: { Id: objectId } };
        case ObjectTypes.CheckListTemplate:
            return { sref: FiStateNames.Checklist.Template.View, srefParams: { Id: objectId } };
        case ObjectTypes.SMSMessage:
            return { sref: FiStateNames.SMS.View, srefParams: { Id: objectId } };
        case ObjectTypes.DataFieldGroup:
            return { sref: 'DataField.EditById', srefParams: { Id: objectId } };
        case ObjectTypes.Statistic2:
            return { sref: FiStateNames.Statistic2.Report.View, srefParams: { id: objectId } };
        case ObjectTypes.Form:
            return { sref: FiStateNames.Form.View, srefParams: { id: objectId } };
        case ObjectTypes.Task:
            return args?.taskV2Mode
                ? { sref: FiStateNames.TaskV2.Details, srefParams: { id: objectId } }
                : { sref: FiStateNames.Task.Details, srefParams: { id: objectId } };
        case ObjectTypes.Task2:
            return { sref: FiStateNames.TaskV2.Details, srefParams: { id: objectId } };
        case ObjectTypes.Checklist2:
            return { sref: FiStateNames.ChecklistV2.ViewByChecklist, srefParams: { id: objectId } };
        case ObjectTypes.Checklist2Audit:
            return { sref: FiStateNames.ChecklistV2Audit.ViewByChecklist, srefParams: { id: objectId } };

        case ObjectTypes.Checklist2Template:
            return { sref: FiStateNames.ChecklistV2.Template.Edit._name, srefParams: { id: objectId } };
        case ObjectTypes.Checklist2AuditTemplate:
            return { sref: FiStateNames.ChecklistV2Audit.Template.Edit._name, srefParams: { id: objectId } };

        case ObjectTypes.ChecklistSchedule:
            return { sref: FiStateNames.ChecklistV2.Schedule.Edit, srefParams: { id: objectId } };
        case ObjectTypes.Checklist2AuditSchedule:
            return { sref: FiStateNames.ChecklistV2Audit.Schedule.Edit, srefParams: { id: objectId } };

        case ObjectTypes.ChecklistToSchedule:
            return { sref: FiStateNames.ChecklistV2.View, srefParams: { id: objectId } };
        case ObjectTypes.ChecklistToAuditSchedule:
            return { sref: FiStateNames.ChecklistV2Audit.View, srefParams: { id: objectId } };

        case ObjectTypes.Onboarding:
            return { sref: FiStateNames.Onboarding.View, srefParams: { id: objectId } };
        case ObjectTypes.TodoList:
            return { sref: FiStateNames.Onboarding.Todo.View, srefParams: { id: objectId } };
        case ObjectTypes.Quiz:
            return { sref: FiStateNames.Onboarding.Quiz.View, srefParams: { id: objectId } };
    }
    return undefined;
}
